import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { FormsModule } from '@angular/forms';

import { MyDatePickerModule } from 'mydatepicker';
// import { AngularMyDatePickerModule } from 'angular-mydatepicker';

import { ToastrModule } from 'ngx-toastr';
import { QuillModule } from 'ngx-quill';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppComponent } from './app.component';
import { NavbarComponent } from './ui/navbar/navbar.component';
import { AppointmentFormComponent } from './appointment/appointment-form/appointment-form.component';
import { McRoutingModule } from './mc-routing.module';
import { PatientListComponent } from './patient/patient-list/patient-list.component';
import { PatientIndexComponent } from './patient/patient-index/patient-index.component';
import { PatientShowComponent } from './patient/patient-show/patient-show.component';
import { PatientFormComponent } from './patient/patient-form/patient-form.component';
import { PatientCardComponent } from './patient/patient-card/patient-card.component';
import { AppointmentIndexComponent } from './appointment/appointment-index/appointment-index.component';
import { AppointmentShowComponent } from './appointment/appointment-show/appointment-show.component';
import { AppointmentDetailComponent } from './appointment/appointment-detail/appointment-detail.component';
import { AppointmentFieldDetailComponent } from './appointment/appointment-field-detail/appointment-field-detail.component';
import { AppointmentFormFieldComponent } from './appointment/appointment-form-field/appointment-form-field.component';
import { PrescriptionIndexComponent } from './prescription/prescription-index/prescription-index.component';
import { PrescriptionFormComponent } from './prescription/prescription-form/prescription-form.component';
import { PatientNewComponent } from './patient/patient-new/patient-new.component';
import { LoginFormComponent } from './login/login-form/login-form.component';
import { HomepageComponent } from './homepage/homepage.component';
import { AppointmentNewComponent } from './appointment/appointment-new/appointment-new.component';
import { PrescriptionTemplateIndexComponent } from './prescription-template/prescription-template-index/prescription-template-index.component';
import { PrescriptionTemplateFormComponent } from './prescription-template/prescription-template-form/prescription-template-form.component';
import { PrescriptionTemplateNewComponent } from './prescription-template/prescription-template-new/prescription-template-new.component';
import { PrescriptionTemplateListComponent } from './prescription-template/prescription-template-list/prescription-template-list.component';
import { PrescriptionTemplateShowComponent } from './prescription-template/prescription-template-show/prescription-template-show.component';
import { SchedulingNewComponent } from './scheduling/scheduling-new/scheduling-new.component';
import { PatientHeaderComponent } from './patient/patient-header/patient-header.component';
import { SchedulingIndexComponent } from './scheduling/scheduling-index/scheduling-index.component';
import { SchedulingFormComponent } from './scheduling/scheduling-form/scheduling-form.component';
import { ChangePasswordComponent } from './login/password/change-password/change-password.component';
import { ExamTemplateIndexComponent } from './exam-template/exam-template-index/exam-template-index.component';
import { ExamTemplateListComponent } from './exam-template/exam-template-list/exam-template-list.component';
import { ExamTemplateNewComponent } from './exam-template/exam-template-new/exam-template-new.component';
import { ExamTemplateFormComponent } from './exam-template/exam-template-form/exam-template-form.component';
import { ExamTemplateShowComponent } from './exam-template/exam-template-show/exam-template-show.component';
import { ExamFormComponent } from './exam/exam-form/exam-form.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

export function tokenGetter() {
  return localStorage.getItem('id_token');
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PatientListComponent,
    PatientIndexComponent,
    PatientShowComponent,
    PatientFormComponent,
    PatientCardComponent,
    AppointmentIndexComponent,
    AppointmentShowComponent,
    AppointmentDetailComponent,
    AppointmentFieldDetailComponent,
    AppointmentFormComponent,
    AppointmentFormFieldComponent,
    PrescriptionIndexComponent,
    PrescriptionFormComponent,
    PatientNewComponent,
    LoginFormComponent,
    HomepageComponent,
    AppointmentNewComponent,
    PrescriptionTemplateIndexComponent,
    PrescriptionTemplateFormComponent,
    PrescriptionTemplateNewComponent,
    PrescriptionTemplateListComponent,
    PrescriptionTemplateShowComponent,
    SchedulingNewComponent,
    PatientHeaderComponent,
    SchedulingIndexComponent,
    SchedulingFormComponent,
    ChangePasswordComponent,
    ExamTemplateIndexComponent,
    ExamTemplateListComponent,
    ExamTemplateFormComponent,
    ExamTemplateNewComponent,
    ExamTemplateShowComponent,
    ExamFormComponent,
  ],
  imports: [
    BrowserModule,
    McRoutingModule,
    FormsModule,
    FontAwesomeModule,
    HttpClientModule,
    MyDatePickerModule,
    // AngularMyDatePickerModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({ progressBar: true, preventDuplicates: true }),
    NgxMaskModule.forRoot(maskConfig),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ['localhost:4200', 'consultorioconectado.com.br']
      }
    }),
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons

          // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'font': [] }],

          // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'align': [] }],

          ['clean'],                                         // remove formatting button

          ['link']                         // link and image, video
          // ['link', 'image', 'video']                         // link and image, video
        ]
      },
      placeholder: ''
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
